const headCells = [
    {
      id: 'Lead ID',
      numeric: false,
      disablePadding: false,
      label:'Lead ID',
    },
    {
      id: 'Lead Name  ',
      numeric: false,
      disablePadding: false,
      label:'Lead Name',
    },
    {
      id: 'Company Name',
      numeric: false,
      disablePadding: false,
      label: 'Company Name',
    },
    {
      id: 'Contact Name',
      numeric: false,
      disablePadding: false,
      label: 'Contact Name',
    },
    {
      id: 'Created By',
      numeric: false,
      disablePadding: false,
      label: 'Created By',
    },
    {
      id: 'Assigned to',
      numeric: false,
      disablePadding: false,
      label: 'Assigned to',
    },
    {
      id: 'Service Provider',
      numeric: false,
      disablePadding: false,
      label: 'Service Provider',
    },
    {
      id: 'Product',
      numeric: false,
      disablePadding: false,
      label: 'Product',   
    },
    {
      id: 'Date of Creation',
      numeric: false,
      disablePadding: false,
      label: 'Date of Creation',   
    },
    {
      id: 'Status',
      numeric: false,
      disablePadding: false,
      label: 'Status',   
    },
    // {
    //   id: 'Action',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Action',   
   // },
    // {
    //   id: 'Assign',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Assign',   
    // },
    
  ];
  
    export { headCells }